import { render } from "./EditCustomerPage.vue?vue&type=template&id=27cc3294&ts=true"
import script from "./EditCustomerPage.vue?vue&type=script&lang=ts"
export * from "./EditCustomerPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__